import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import ImagePicker from "@/components/composer/ImagePicker";
import api, { errMsg } from "@/lib/api";

export default function TemplateDialog({ template, onClose, onSaved }) {
  const [name, setName] = useState("");
  const [content, setContent] = useState("");
  const [imageId, setImageId] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (template) { setName(template.name || ""); setContent(template.content || ""); setImageId(template.image_id || null); }
  }, [template]);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    const body = { name, content, image_id: imageId };
    try {
      if (template?.id) await api.put(`/templates/${template.id}`, body);
      else await api.post("/templates", body);
      toast.success("Template disimpan");
      onSaved();
      onClose();
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <Dialog open={!!template} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="border-border bg-card sm:max-w-lg" data-testid="template-dialog">
        <DialogHeader>
          <DialogTitle>{template?.id ? "Edit template" : "Template baharu"}</DialogTitle>
          <DialogDescription>Teks ini boleh diguna semula setiap kali anda menulis post.</DialogDescription>
        </DialogHeader>
        <form onSubmit={save} className="space-y-4">
          <div className="space-y-2"><Label>Nama template</Label><Input required value={name} onChange={(e) => setName(e.target.value)} placeholder="cth: Promosi hujung minggu" data-testid="template-name-input" /></div>
          <div className="space-y-2"><Label>Teks post</Label><Textarea required rows={7} value={content} onChange={(e) => setContent(e.target.value)} data-testid="template-content-input" /></div>
          <ImagePicker imageId={imageId} setImageId={setImageId} />
          <Button type="submit" disabled={busy} className="w-full" data-testid="template-save-btn">{busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Simpan</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
